// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { TipoArticuloProps } from '../interfaces'
import { tipoArticuloFragment } from '../interfaces/tipoArticuloFragment'

const query = gql`
  ${tipoArticuloFragment}
  mutation ACTUALIZAR($codigo: String!, $input: TipoArticuloInput!) {
    tipoArticuloActualizar(codigo: $codigo, input: $input) {
      ...tipoArticuloFragment
    }
  }
`
/**
 * Actualizamos un tipo de articulo
 * @param codigo
 * @param input
 */
export const apiTipoArticuloActualizar = async (
  codigo: string,
  input: {
    descripcion: string
  },
): Promise<TipoArticuloProps> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)
    const data: any = await client.request(query, {
      codigo,
      input,
    })
    return data.tipoArticuloActualizar
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
